export default __webpack_public_path__ + "static/media/chat.39597718.webp";